module.exports = __webpack_public_path__ + "static/media/on_deck.5323c36a.png";